import { GiftsCacheState } from "src/state/tree/giftsCache.type";

export const getDefaultPremiumMessageGiftIds = (state: GiftsCacheState) =>
  state.defaultPremiumMessageGiftIds;

export const getOneClickFlowLocation = (state: GiftsCacheState) =>
  state.oneClickFlowLocation;
